import { Component, Inject } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogConfig } from '@models';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  imports: [LoaderComponent, MatDialogTitle, MatDialogContent, MatDialogActions, MatRipple],

  selector: 'monitor-ui-dialog',
  styleUrls: ['./dialog.component.scss'],
  templateUrl: './dialog.component.html',
})
export class DialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfig,
  ) {}
}
